<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i class="pi pi-upload title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{'misc.importMeasuresCsv' | transloco}}
            </p>
            <!--<p *ngIf="entityType && entityType === 'devices'">
              {{'model.device' | transloco}} {{device.serialNumber}} ({{device.organization.name}})
            </p>
            <p *ngIf="entityType && entityType === 'assets'">
              {{'model.asset' | transloco}} {{asset.alias}} ({{asset.organization.name}})
            </p>
            <p *ngIf="entityType && entityType === 'kpis'">
              {{'model.kpi' | transloco}} {{kpi.name}}
            </p>-->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">
        <p-panel [(collapsed)]="infoCollapsed" [toggleable]="true" class="mb-4 card p-0" styleClass="p-panel-white-header">
          <ng-template pTemplate="header">
            <div class="flex align-items-center p-2">
              <i class="pi pi-info-circle text-xl" (click)="infoCollapsed = !infoCollapsed"></i>
              <p class="ml-2 mb-0 text-xl" style="margin-top: 1px;">{{'common.information' | transloco}}</p>
            </div>
          </ng-template>
          <div class="flex">
            <ul class="mt-0 mb-1">
              <li class="line-height-3">{{'info.importCsv.format' | transloco}}</li>
              <li class="line-height-3">{{'info.importMeasurementsCsv.fieldsInfo' | transloco}}</li>
              <div class="mt-2 mb-2">
                <i class="font-medium">{{'info.importMeasurementsCsv.fields.name' | transloco}} ;
                  {{'info.importMeasurementsCsv.fields.timestamp' | transloco}} ;
                  {{'info.importMeasurementsCsv.fields.value' | transloco}} ;
                  {{'info.importMeasurementsCsv.fields.unit' | transloco}}
                </i>
              </div>
              <li class="line-height-3">{{'info.importMeasurementsCsv.timestamp' | transloco}}</li>
              <li class="line-height-3">{{'info.importMeasurementsCsv.optional' | transloco}}</li>
            </ul>
          </div>
        </p-panel>

        <div class="grid mb-2">
          <div [ngClass]="files.length > 0 || filesUploaded ? 'col-3': 'col-12'">
            <div class="card h-20rem p-0">
              <app-upload-csv [fileExtensions]="['csv']" (onFileDropped)="this.processFiles($event)"
                              [disabled]="!this.loadedData"></app-upload-csv>
            </div>
          </div>

          <div *ngIf="filesUploaded" class="col-9">
            <div class="card h-20rem p-0">
              <div class="flex h-full ">
                <div class="flex m-auto">
                  <div class="w-full">
                    <div class="flex upload rounded-lg shadow-sm">
                      <div class="m-auto">
                        <div class="icon w-full flex">
                          <i class="pi pi-check-circle m-auto success-color"
                             style="font-size: 62px"></i>
                        </div>
                        <div class="text-center mt-4">
                          <p>{{'info.importCsv.uploaded' | transloco}}</p>
                          <button pButton class="md:mr-2 p-button-primary my-2 md:mb-0" [routerLink]="'/system/csv-history'">
                            {{'info.importCsv.seeStatus' | transloco}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="files.length > 0 && !filesUploaded" class="col-9">
            <div class="card overflow-auto" [ngStyle]="{'max-height': '20rem'}">
              <p-accordion>
                <p-accordionTab *ngFor="let fileData of files; index as fileIndex"
                                [disabled]="fileData.fileErrors == null">
                  <p-header class="w-full">
                    <div class="flex align-items-center justify-content-between w-full ml-2">
                      <div class="w-3rem">
                        <i *ngIf="fileData.fileErrors != null" class="pi pi-file danger-color"
                           style="font-size: 30px"></i>
                        <i *ngIf="fileData.fileErrors == null" class="pi pi-file success-color"
                           style="font-size: 30px"></i>
                      </div>
                      <div class="w-full flex">
                        <p class="mb-0 line-height-4">{{ fileData.file.name }}</p>
                        <p class="p-12 ml-4 mb-0 line-height-4 font-normal">{{fileData.file.size / 1048576 | number:
                          '1.2-2'}} MB</p>
                      </div>
                      <div class="w-3rem flex flex-column md:flex-row justify-content-end">
                        <button (click)="deleteAttachment(fileIndex)" pButton pRipple
                                class="p-button-rounded btn-danger-light pointer-events-auto"
                                style="cursor: pointer !important;" icon="pi pi-trash">
                        </button>
                      </div>
                    </div>
                  </p-header>
                  <p-content>
                    <div *ngIf="fileData.fileErrors != null">
                      <div class="my-3">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                             style="font-size: 1.5rem"></i>
                          <div>
                            {{'error.importCsv.wrongFileFormat' | transloco}}
                          </div>
                        </h5>
                        <ul>
                          <li *ngFor="let lineError of fileData.fileErrors?.lines">
                            {{ 'error.importCsv.cannotImportMeasurementOfLine' | transloco: {line: lineError + 1} }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </p-content>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>

        <div *ngIf="filesLoaded && !filesUploaded" class="card flex flex-column">
          <div class="card-header pt-1">
            <div class="flex w-full align-items-center justify-content-between">
              <div class="inline mb-1">
                <h4 class="mt-1 inline">{{'info.importMeasurementsCsv.measurementsToImport' | transloco}}</h4>
              </div>
            </div>
          </div>
          <hr>
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <p-table [(first)]="first"
                     [(rows)]="rows"
                     [paginator]="true"
                     [responsive]="true"
                     responsiveLayout="stack"
                     breakpoint="1700px"
                     [rowsPerPageOptions]="[10,25,50]"
                     [totalRecords]="totalMeasurements"
                     [value]="measurements"
                     styleClass="p-datatable-striped"
                     dataKey="lineIdentifier">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'info.importMeasurementsCsv.fields.name' | transloco}} (*)</th>
                  <th>{{'info.importMeasurementsCsv.fields.timestamp' | transloco}} (*)</th>
                  <th>{{'info.importMeasurementsCsv.fields.value' | transloco}} (*)</th>
                  <th>{{'info.importMeasurementsCsv.fields.unit' | transloco}}</th>
                  <th class="w-4rem">{{'attribute.state' | transloco}}</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-csvMeasurementData let-expanded="expanded">
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'info.importMeasurementsCsv.fields.name' | transloco}}</span>
                    <span *ngIf="csvMeasurementData.measurement?.name">{{csvMeasurementData.measurement?.name}}</span>
                    <span *ngIf="!csvMeasurementData.measurement?.name"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'info.importMeasurementsCsv.fields.timestamp' | transloco}}</span>
                    <span *ngIf="csvMeasurementData.measurement?.timestamp && isValidDate(csvMeasurementData.measurement?.timestamp)">
                      {{parseToNumber(csvMeasurementData.measurement?.timestamp) | customDate}}</span>
                    <span *ngIf="csvMeasurementData.measurement?.timestamp && !isValidDate(csvMeasurementData.measurement?.timestamp)">
                      {{csvMeasurementData.measurement?.timestamp}}</span>
                    <span *ngIf="!csvMeasurementData.measurement?.timestamp"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'info.importMeasurementsCsv.fields.value' | transloco}}</span>
                    <span *ngIf="csvMeasurementData.measurement?.value">{{csvMeasurementData.measurement?.value}}</span>
                    <span *ngIf="!csvMeasurementData.measurement?.value"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'info.importMeasurementsCsv.fields.unit' | transloco}}</span>
                    <span *ngIf="csvMeasurementData.measurement?.unit">{{csvMeasurementData.measurement?.unit}}</span>
                    <span *ngIf="!csvMeasurementData.measurement?.unit"></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.state' | transloco}}</span>
                    <div class="flex justify-content-center">
                      <div class="pr-4" *ngIf="csvMeasurementData.status === 'CORRECT'">
                        <i class="pi pi-check-circle align-self-center success-color"
                           style="font-size: 1.5rem"></i>
                      </div>

                      <div class="flex" *ngIf="csvMeasurementData.status === 'ERROR'">
                        <button type="button" pButton pRipple [pRowToggler]="csvMeasurementData"
                                class="p-button-text p-button-rounded p-button-plain">
                          <i class="pi pi-times-circle align-self-center danger-color"
                             style="font-size: 1.5rem"></i>
                          <i class="align-self-center ml-2 line-height-3"
                             [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                             style="font-size: 0.7rem"></i>
                        </button>
                      </div>
                      <div class="pr-4" *ngIf="csvMeasurementData.status === 'PROCESSING'">
                        <i class="pi pi-spin pi-spinner align-self-center"
                           style="font-size: 1.5rem"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="rowexpansion" let-csvMeasurementData>
                <tr>
                  <td colspan="16">
                    <div class="overflow-auto" [ngStyle]="{'max-height': '15rem'}">
                      <div class="my-3" *ngFor="let propertyErrors of csvMeasurementData.errors | keyvalue">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                             style="font-size: 1.5rem"></i>
                          <div>
                            {{this.measurementPropertiesErrors.getTranslation(propertyErrors.key)}} </div>
                        </h5>
                        <ul>
                          <li *ngFor="let error of propertyErrors.value">
                            {{ 'error.importCsv.' + error.message | transloco: error.params }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="measurements.length == 0">
                  {{'pagination.empty'| transloco}}</div>
                <div class="flex align-items-center justify-content-between" *ngIf="totalMeasurements > 0">
                  {{'pagination.showing' | transloco}} {{first + 1}}
                  {{'pagination.to' | transloco}} {{(first + rows) >= totalMeasurements ? totalMeasurements : (first + rows)}}
                  {{'pagination.of' | transloco}} {{totalMeasurements}}
                  {{(totalMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>

            </p-table>
          </div>
          <div class="grid">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco"
                          (click)="cancel()"
                          pButton
                          class="p-button-danger"
                          iconPos="right">
                  </button>
                  <p-button [label]="'common.import' | transloco"
                            [disabled]="this.filesWithoutErrors?.length === 0"
                            [loading]="uploadingMeasurements"
                            (onClick)="confirmImport()"
                            styleClass="p-button-primary">
                  </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
